import { $display } from './context.js'

/**
 * Popup para la ficha técnica.
 */
export const initSpecSheet = () => {
    $display.on('click', '.btn-spec-sheet', (event, self) => {
        const url = self.attr('data-spec-sheet')
        if (!url) return
        window.open(url, 'Ver ficha técnica', 'width=500,height=500,resizable,scrollbars,status').focus()
    })
}
